// export { default as orderConfirm } from './orderConfirm/orderConfirm.vue';
export const orderConfirm = (r) => require.ensure([], () => r(require("./orderConfirm/orderConfirm.vue")), "orderConfirm");
export const orderList = (r) => require.ensure([], () => r(require("./orderList/orderList.vue")), "orderList");
export const orderInfo = (r) => require.ensure([], () => r(require("./orderInfo/orderInfo.vue")), "orderInfo");
export const logistics = (r) => require.ensure([], () => r(require("./logistics/logistics.vue")), "logistics");
